// The App Store URL carries no country segment so Apple opens the visitor's own
// storefront instead of forcing the US one.
export const CUSTOMER_APP_STORES = {
  appStore:
    "https://apps.apple.com/app/lime-booking-for-customers/id6768622324",
  googlePlay:
    "https://play.google.com/store/apps/details?id=com.lime.marketplace",
} as const;

export type CustomerAppStore = keyof typeof CUSTOMER_APP_STORES;

// The bare origin redirects to the visitor's own language.
export const CUSTOMER_MARKETPLACE_URL = "https://lime-booking.com";
